/**
 * @desc 根据包裹单号获取合同信息
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/getContractInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
